// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"501254e4","455":"a04ff392","762":"477f56f9","977":"d45717b1"}[chunkId] + ".chunk.js";
};